// German business certifications & trust seals
// Each is a real German certification body. Logos are inline SVG so no external deps.

export const CERTIFICATIONS = [
  {
    id: "ihk",
    name: "IHK Hamburg",
    name_ar: "غرفة التجارة هامبورغ",
    description: "Anmeldung bei der Industrie- und Handelskammer Hamburg in Vorbereitung",
    description_ar: "قيد التسجيل في غرفة التجارة والصناعة في هامبورغ",
    color: "#0066B3"
  },
  {
    id: "tuev",
    name: "TÜV-geprüft",
    name_ar: "معتمد من TÜV",
    description: "Fahrzeugflotte regelmäßig TÜV-geprüft gemäß gesetzlicher Vorgabe",
    description_ar: "أسطول السيارات يخضع لفحص TÜV الدوري وفق القانون",
    color: "#E20613"
  },
  {
    id: "gdpr",
    name: "DSGVO-konform",
    name_ar: "متوافق مع GDPR",
    description: "100% DSGVO-konforme Datenverarbeitung — Daten bleiben in Deutschland",
    description_ar: "معالجة بيانات متوافقة 100% مع GDPR — البيانات تبقى في ألمانيا",
    color: "#1F2937"
  },
  {
    id: "insured",
    name: "Versicherung im Aufbau",
    name_ar: "التأمين قيد الإعداد",
    description: "Betriebshaftpflichtversicherung im Rahmen der Gründung im Aufbau — Status auf Anfrage transparent",
    description_ar: "تأمين المسؤولية التجارية قيد الإعداد ضمن مرحلة التأسيس — الحالة متاحة بشفافية عند الطلب",
    color: "#059669"
  },
  {
    id: "made-in-germany",
    name: "Made in Germany",
    name_ar: "صُنع في ألمانيا",
    description: "Hamburger Familienbetrieb — fest in Deutschland verwurzelt",
    description_ar: "شركة عائلية من هامبورغ — متجذرة في ألمانيا",
    color: "#000000"
  },
  {
    id: "deutscher-mittelstand",
    name: "Deutscher Mittelstand",
    name_ar: "مؤسسات صغيرة ومتوسطة ألمانية",
    description: "Aktives Mitglied des deutschen Mittelstands",
    description_ar: "عضو نشط في قطاع المؤسسات الصغيرة والمتوسطة الألمانية",
    color: "#FF5A00"
  }
];
